<template>
  <div class="invite-team-add-player" >
    <van-cell-group>
      <van-cell title="头像" >
        <template>
          <div class="teamIcon" >
            <van-uploader class="uploader" :after-read="onRead" :disabled="isRead">
              <img v-if="profileImg" :src="profileImg" alt="">
              <img v-if="!profileImg" src="@/assets/images/team-logo-empty.png">
            </van-uploader>
          </div>
        </template>
      </van-cell>
      <van-cell title="姓名" :value="player.trueName" is-link @click="setValues('trueName')" />
      <van-cell title="球衣号码" :value="player.number" is-link @click="setValues('number')" />
      <van-cell title="场上位置" :value="player.position" is-link @click="isShowPosition = true" />
      <van-cell title="联系方式" :value="player.mobile" is-link @click="setValues('mobile')" />
      <van-cell title="身份证号" :value="player.IDCardNumber" is-link @click="setValues('IDCardNumber')" />
      <van-cell title="身份证照片" is-link @click="goUploadCard" />
    </van-cell-group>
    <div class="foot" >
      <van-button type="primary" size="large" @click="createBMPlayer" >确认</van-button>
    </div>

    <van-popup v-model="PopupShow" position="right" class="popup" >
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" >
        <van-col span="18" >
          <van-cell-group>
            <van-field v-model="player[key]" placeholder="请输入..." />
          </van-cell-group>
        </van-col>
        <van-col span="5" align="right" >
          <van-button type="primary" @click="PopupShow=false" >确认</van-button>
        </van-col>
      </van-row>
    </van-popup>

    <van-popup v-model="isShowPosition" position="bottom" >
      <van-picker
        show-toolbar
        @cancel="isShowPosition = false"
        @confirm="ConfirmPosition"
        :columns="columns"
        @change="positionTab"
      />
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { ImageFormat, varConfig } from '@/utils/'
import { getQiniuUploadToken } from '@/api/user'
import { updateBMPlayer, createBMPlayerByUser } from '@/api/team'
import { Cell, CellGroup, Button, Popup, Picker, Toast } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Picker).use(Toast)

const citys = {
  '前锋': ['CF中锋', 'SS影子前锋', 'LWF左边锋', 'RWF右边锋'],
  '中锋': ['CAM前腰', 'CDM后腰', 'CM中前卫', 'LM左前卫', 'RM右前卫'],
  '后卫': ['CB中后卫', 'SW清道夫', 'LB左后卫', 'RB左后卫'],
  '门将': ['门将'],
  '其它': ['其它']
}
export default {
  name: 'PlayerDetailed',
  data () {
    return {
      query: '',
      PopupShow: false,
      teamName: '',
      teamId: null,
      matchId: null,
      player: {},
      playerId: null,
      key: null,
      columns: [
        {
          values: Object.keys(citys),
          className: 'column1'
        },
        {
          values: citys['前锋'],
          className: 'column2',
          defaultIndex: 0
        }
      ],
      isShowPosition: false,
      isRead: false,
      qiniuToken: ''
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.squareImageView(this.player.photo, 100)
    },
    isUploadId() {
      if (this.player.IDCardPhotoA && this.player.IDCardPhotoB) {
        return '已上传'
      } else if (this.player.IDCardPhotoA || this.player.IDCardPhotoB) {
        return '未上传完整'
      } else {
        return '未上传'
      }
    }
  },
  created() {
    this.query = this.$route.query
    this.matchId = this.query.matchId
    // if (!this.matchId || !this.teamId) {
    //  Toast('参数错误')
    //  return
    // }
    this.getQiniuToken()
  },
  methods: {
    setValues(key) {
      this.key = key
      this.PopupShow = true
    },
    ConfirmPosition(value) {
      this.player.position = value.join('|')
      this.isShowPosition = false
    },
    positionTab(picker, values) {
      picker.setColumnValues(1, citys[values[0]])
    },
    createBMPlayer() {
      const params = {
        playerId: this.player.id,
        photo: this.player.photo,
        position: this.player.position,
        trueName: this.player.trueName,
        number: this.player.number,
        mobile: this.player.mobile,
        IDCardNumber: this.player.IDCardNumber,
        IDCardPhotoA: this.player.IDCardPhotoA,
        IDCardPhotoB: this.player.IDCardPhotoB
      }
      updateBMPlayer(params).then((res) => {
        const data = res.data
        if (data) {
          Toast('更新成功')
        }
      })
    },
    createBMPlayerByUser() {
      const params = {
        teamId: this.teamId,
        matchId: this.matchId,
        userIds: this.result.join()
      }
      createBMPlayerByUser(params).then(response => {
        const data = response.data
        if (data) {
          Toast('添加参赛球员成功')
          this.$router.push({name: 'InviteTeamInfo', query: {matchId: this.matchId, teamId: this.teamId}})
        }
      })
    },
    goUploadCard() {
      this.$router.push({ name: 'UploadFile',
        query: { playerId: this.playerId,
          cardA: this.player.IDCardPhotoA,
          cardB: this.player.IDCardPhotoB,
          trueName: this.player.trueName,
          number: this.player.number,
          photo: this.player.photo,
          position: this.player.position,
          mobile: this.player.mobile,
          IDCardNumber: this.player.IDCardNumber
        }
      })
    },
    onRead(file) {
      console.log(file)
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.photo = res.hash
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    }
  }
}
</script>

<style lang="stylus">
  .invite-team-add-player
    background-color: white
    width 100%
    height: 100%
    position absolute
    .van-cell-group
      .van-cell:not(:last-child)::after
        right: 15px
      .van-cell:first-child
        .van-cell__title
          display flex
          align-content center
          align-items: center;
      .van-cell
        font-size:14px;
        font-weight:300;
        color:rgba(74,74,74,1);
        .van-icon::before
          color: #000000
    .teamIcon
      width 50px
      height 50px
      background:rgba(230,230,230,1);
      border-radius:50px;
      float: right
      img
        width 50px
        height: 50px;
        border-radius: 50%;
    .foot
      position absolute
      bottom 0
      width 100%
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #32A377;
        line-height:25px;
      .van-button--primary
        background-color #FAFAFA
        font-size:20px;
        font-weight:400;
    .popup
      width 100%
      height: 100%
      background-color white
      .van-button
        background-color #32a377
</style>



// WEBPACK FOOTER //
// src/pages/invite-team/captain/player-add.vue